import { RootState } from "@store/store";
import React from "react";
import { useSelector } from "react-redux";
import HealthScores from "src/Components/GlobalComponents/HealthProfiles/HealthScores";
import TextLineSection from "src/Components/WebsiteComponents/HomePage/TextLineSection";

const HealthScorePage = () => {
  const { userDetails } = useSelector((state: RootState) => state.appReducer);
  return (
    <div className="w-full bg-banner-white-image">
      <div className="view-area-width mx-auto p-5 ">
        <HealthScores id={userDetails?._id} isAdmin={false} parentBoxClassName="inner-max-width mb-0" />
      </div>      
    </div>
  );
};

export default HealthScorePage;
